import { render, staticRenderFns } from "./TheMatriculasTable.vue?vue&type=template&id=cd44a5f0&scoped=true"
import script from "./TheMatriculasTable.vue?vue&type=script&lang=js"
export * from "./TheMatriculasTable.vue?vue&type=script&lang=js"
import style0 from "./TheMatriculasTable.vue?vue&type=style&index=0&id=cd44a5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd44a5f0",
  null
  
)

export default component.exports